import * as d3 from 'd3';

export function buildXScale(data, availableWidth) {
  return d3
    .scaleTime()
    .domain(d3.extent(data, (d) => d.date))
    .range([0, availableWidth]);
}

// Generic linear y-scale from an [min,max] extent, with a small padding
// ratio so the mark never touches the pane's top/bottom edge.
export function buildYScale(extent, height, paddingRatio = 0.06) {
  const [min, max] = extent;
  const span = max - min || Math.abs(max) || 1;
  const pad = span * paddingRatio;
  return d3
    .scaleLinear()
    .domain([min - pad, max + pad])
    .range([height, 0]);
}

export function buildVolumeYScale(data, height) {
  return d3
    .scaleLinear()
    .domain([0, d3.max(data, (d) => d.volume) || 1])
    .range([height, 0])
    .nice();
}

export function buildSubYScale(domain, height, paddingRatio = 0.04) {
  const [min, max] = domain;
  const span = max - min || 1;
  const pad = span * paddingRatio;
  return d3
    .scaleLinear()
    .domain([min - pad, max + pad])
    .range([height, 0])
    .nice();
}
